import type { PartialDeep, UndefinedOnPartialDeep } from 'type-fest';

import { translate } from '@repo/phrase';
import { Heading, Paragraph } from '@repo/ui/typography';

import { formatPrice } from '@/utils/translation.utils';

import styles from './styles.module.scss';

export interface ArticleTitleDetail {
    groupCount: number;
    itemCount: number;
    packageCount: number;
    weight: number;
    unit: string;
    totalPrice: number;
    currency: string;
}
interface Props {
    titleDetail: UndefinedOnPartialDeep<PartialDeep<ArticleTitleDetail>> | undefined;
}

export const ArticleTitle = ({ titleDetail }: Props) => {
    if (!titleDetail) {
        return (
            <div data-testid="article-title-empty" className={styles.article_title}>
                <div className={styles.article_title_left}>
                    <Heading headingSize="xs">{translate('article_title')}</Heading>
                </div>
            </div>
        );
    }

    const groups = translate('article_title_group', {
        number: titleDetail.groupCount?.toFixed(0) ?? '0',
    });
    const items = translate('article_title_item', {
        number: titleDetail.itemCount?.toFixed(0) ?? '0',
    });
    const packages = translate('article_title_package', {
        number: titleDetail.packageCount?.toFixed(0) ?? '0',
    });
    const weight = translate('article_title_weight', {
        number: titleDetail.weight?.toFixed(1) ?? '0',
        unit: titleDetail.unit?.toString() ?? '',
    });
    const price = formatPrice(titleDetail.totalPrice, titleDetail.currency);

    return (
        <div data-testid="article-title" className={styles.article_title}>
            <div className={styles.article_title_left}>
                <Heading headingSize="xs">{translate('article_title')}</Heading>
                <Paragraph>
                    {groups}, {items} • {packages} • {weight}
                </Paragraph>
            </div>
            <div className={styles.article_title_right}>
                <Paragraph>{translate('article_title_total')}</Paragraph>
                <Paragraph className={styles.price_total ?? ''}>{price}</Paragraph>
            </div>
        </div>
    );
};
